import axiosInstance from "../../../helpers/api";

export const getAllLessons = (body) => {
    return axiosInstance.get('/superadmin/pdfs', body);
};

export const editLessons = (formData) => {
    return axiosInstance.post(`/superadmin/pdfs/${formData.id}`, formData.formData);
};


export const createLessons = (formData) => {
    return axiosInstance.post('/superadmin/pdfs', formData);
};

export const deleteLesson = (id) => {
    return axiosInstance.delete(`/superadmin/pdfs/${id}`);
};
